import React from 'react';

import { CustomLoginLogo } from 'v-c/Login';

export default function LoginLogo(loginLogoPath, DefaultLogo) {
    if (loginLogoPath && loginLogoPath.length) {
        return (
            <CustomLoginLogo src={loginLogoPath}>
                <noscript />
            </CustomLoginLogo>
        );
    }

    return <DefaultLogo />;
}
